Vendd.Scripts.load(function () {

    var messages = {};

    messages.datasourceChanged = function (datasourceId) {

        var data = {
            datasourceId: datasourceId
        };

        Vendd.MessageBus.VenddMessage.call(this, 'Vendd.inlineEdit.messages.datasourceChanged', data);
    };
    messages.datasourceChanged.className = 'Vendd.inlineEdit.messages.datasourceChanged';

    var Vendd = window.Vendd || {};

    Vendd.inlineEdit.messages = messages;

});